import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c(
                VRow,
                [
                  _c("select-simple-unidade", {
                    attrs: {
                      value: _vm.unidade,
                      "mapeamento-id": _vm.diagnostico.mapeamento.id,
                    },
                  }),
                ],
                1
              ),
              _c("relatorio-gerencial-responsabilidade", {
                attrs: {
                  unidades: _vm.unidadesSelecionadasParam,
                  "is-uma-unidade": "",
                  diagnostico: _vm.diagnostico,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }